module.exports = __webpack_public_path__ + "img/people2.7b3bc053.png";